import { Subject } from 'rxjs';

const subject = new Subject();

export const userDetailService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};